module.exports = __webpack_public_path__ + "static/media/InnovationCell.76ff9c4c.jpg";